import React, { useEffect, useState } from 'react';
import { getSiteSettings, saveSiteSettings } from '../../api/siteSettingsApi';

const DEFAULT = { confetti: true, ticker: { enabled: true, items: [] }, popup: { enabled: true, title: '', content: '' } };

const AdminSettings = () => {
  const [settings, setSettings] = useState(DEFAULT);
  const [newItem, setNewItem] = useState('');
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getSiteSettings().then(setSettings);
  }, []);

  const save = async (updated) => {
    setError('');
    try {
      await saveSiteSettings(updated);
      setSettings(updated);
      window.dispatchEvent(new CustomEvent('siteSettings:update', { detail: updated }));
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch {
      setError('שגיאה בשמירה, נסי שוב');
    }
  };

  const addTickerItem = () => {
    if (!newItem.trim()) return;
    save({ ...settings, ticker: { ...settings.ticker, items: [...(settings.ticker.items || []), newItem.trim()] } });
    setNewItem('');
  };

  const removeTickerItem = (idx) => {
    save({ ...settings, ticker: { ...settings.ticker, items: settings.ticker.items.filter((_, i) => i !== idx) } });
  };

  const rowStyle = { display: 'flex', alignItems: 'center', gap: '1rem', fontSize: '1.1rem', marginBottom: '1.2rem' };
  const btnStyle = (active) => ({
    padding: '0.4rem 1.2rem', borderRadius: '20px', border: 'none', cursor: 'pointer',
    fontWeight: 'bold', fontSize: '1rem', background: active ? '#0cad5e' : '#ccc', color: '#fff', transition: 'background 0.2s',
  });
  const inputStyle = { width: '100%', padding: '0.5rem 0.7rem', borderRadius: '8px', border: '1px solid #ddd', fontSize: '1rem', direction: 'rtl', boxSizing: 'border-box' };

  return (
    <div style={{ padding: '2rem', direction: 'rtl', maxWidth: 520 }}>
      <h2 style={{ marginBottom: '1.5rem' }}>הגדרות אתר</h2>

      {error && <div style={{ color: '#d32f2f', marginBottom: '1rem' }}>{error}</div>}

      <div style={rowStyle}>
        <span>קונפטי באתר</span>
        <button onClick={() => save({ ...settings, confetti: !settings.confetti })} style={btnStyle(settings.confetti)}>
          {settings.confetti ? 'פעיל ✓' : 'כבוי'}
        </button>
      </div>

      <hr style={{ margin: '1.5rem 0', borderColor: '#eee' }} />

      <h3 style={{ marginBottom: '1rem', color: '#d32f2f' }}>מבזקי מבצעים</h3>

      <div style={rowStyle}>
        <span>פס מבצעים פעיל</span>
        <button onClick={() => save({ ...settings, ticker: { ...settings.ticker, enabled: !settings.ticker.enabled } })} style={btnStyle(settings.ticker.enabled)}>
          {settings.ticker.enabled ? 'פעיל ✓' : 'כבוי'}
        </button>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: 'bold' }}>הוסף מבצע</label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <input
            style={{ ...inputStyle, flex: 1 }}
            value={newItem}
            onChange={e => setNewItem(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && addTickerItem()}
            placeholder="טקסט המבצע..."
          />
          <button onClick={addTickerItem} style={{ ...btnStyle(true), background: '#d32f2f', padding: '0.5rem 1rem', whiteSpace: 'nowrap' }}>
            הוסף
          </button>
        </div>
      </div>

      <div style={{ marginBottom: '1.5rem' }}>
        {(settings.ticker.items || []).length === 0 && (
          <div style={{ color: '#999', fontSize: '0.9rem' }}>אין מבצעים - יוצגו ברירות מחדל</div>
        )}
        {(settings.ticker.items || []).map((item, idx) => (
          <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem', background: '#fff5f5', borderRadius: '8px', padding: '0.4rem 0.8rem', border: '1px solid #fcc' }}>
            <span style={{ flex: 1 }}>{item}</span>
            <button onClick={() => removeTickerItem(idx)} style={{ background: 'none', border: 'none', color: '#d32f2f', cursor: 'pointer', fontSize: '1.1rem', fontWeight: 'bold' }}>✕</button>
          </div>
        ))}
      </div>

      <hr style={{ margin: '1.5rem 0', borderColor: '#eee' }} />

      <h3 style={{ marginBottom: '1rem', color: '#a261a7' }}>הודעה קופצת</h3>

      <div style={rowStyle}>
        <span>הודעה פעילה</span>
        <button onClick={() => save({ ...settings, popup: { ...settings.popup, enabled: !settings.popup.enabled } })} style={btnStyle(settings.popup.enabled)}>
          {settings.popup.enabled ? 'פעיל ✓' : 'כבוי'}
        </button>
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: 'bold' }}>כותרת</label>
        <input
          style={inputStyle}
          value={settings.popup.title}
          onChange={e => save({ ...settings, popup: { ...settings.popup, title: e.target.value } })}
          placeholder="כותרת ההודעה..."
        />
      </div>

      <div style={{ marginBottom: '1.2rem' }}>
        <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: 'bold' }}>תוכן</label>
        <textarea
          style={{ ...inputStyle, minHeight: 100, resize: 'vertical' }}
          value={settings.popup.content}
          onChange={e => save({ ...settings, popup: { ...settings.popup, content: e.target.value } })}
          placeholder="תוכן ההודעה..."
        />
      </div>

      <div style={{ color: '#0cad5e', minHeight: '1.5rem', fontWeight: 'bold' }}>
        {saved ? 'נשמר ✓' : ''}
      </div>
    </div>
  );
};

export default AdminSettings;
